import { render, staticRenderFns } from "./CashBoxSetting.vue?vue&type=template&id=63ddae2c&"
import script from "./CashBoxSetting.vue?vue&type=script&lang=js&"
export * from "./CashBoxSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports